import { render } from "./ProductCustomization.vue?vue&type=template&id=ffd60608"
import script from "./ProductCustomization.vue?vue&type=script&lang=js"
export * from "./ProductCustomization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__